<template>
  <div class="chat-box">
    <div class="chat-header">
      <div class="chat-title">
        {{ $t("chatbox.title") }}
      </div>
    </div>
    <div class="chat-messages" ref="messagesContainer">
      <div
        v-for="(message, index) in messages"
        :key="index"
        :class="['message', message.type]"
      >
        <img
          v-if="message.type === 'ai'"
          src="@/assets/logo.png"
          alt="AI"
          class="avatar ai-avatar"
        />
        <div class="message-content">{{ message.text }}</div>
      </div>
    </div>
    <div class="chat-input">
      <input
        type="text"
        v-model="newMessage"
        @keyup.enter="gochatbox"
        :placeholder="$t('chatbox.placeholder')"
      />
      <button @click="gochatbox">
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatBox",
  data() {
    return {
      newMessage: "",
    };
  },
  computed: {
    messages() {
      return [
        {
          type: "ai",
          text: this.$t("chatbox.initialMessage"),
        },
      ];
    },
  },
  methods: {
    sendMessage() {
      if (this.newMessage.trim() === "") return;

      // 用户消息
      const userMessage = {
        type: "user",
        text: this.newMessage,
      };

      // 模拟AI回复
      const aiMessage = {
        type: "ai",
        text: this.getRandomResponse(),
      };

      // 使用响应式方法更新消息
      const updatedMessages = [...this.messages, userMessage, aiMessage];
      this.$set(this, "messages", updatedMessages);

      this.newMessage = "";
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    getRandomResponse() {
      const responses = this.$t("chatbox.responses");
      return responses[Math.floor(Math.random() * responses.length)];
    },
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
      container.scrollTop = container.scrollHeight;
    },
    gochatbox() {
      const baseUrl = "https://app.tripseek.cn/chat/6WDpv4lTX8lLkdXr";
      if (this.newMessage && this.newMessage.trim() != "") {
        location.href = `${baseUrl}?query=${encodeURIComponent(
          this.newMessage
        )}&type=conversation`;
      } else {
        location.href = `${baseUrl}?type=conversation`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.chat-box {
  width: 100%;
  height: 100%;
  min-height: 600px;
  max-height: 800px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%);
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(26, 86, 219, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  border: 2px solid rgba(26, 86, 219, 0.1);

  .chat-header {
    background: linear-gradient(135deg, #1a56db 0%, #2563eb 100%);
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    font-weight: 600;

    .chat-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 1.2rem;

      .fa-robot {
        color: #1a56db;
        font-size: 1.5rem;
      }
    }

    .chat-actions {
      display: flex;
      gap: 15px;
      color: rgba(255, 255, 255, 0.7);

      i {
        cursor: pointer;
        transition: color 0.2s;
        font-size: 1rem;

        &:hover {
          color: white;
        }
      }
    }
  }

  .chat-messages {
    flex-grow: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
    background: rgba(255, 255, 255, 0.6);

    .message {
      display: flex;
      align-items: flex-start;
      gap: 15px;
      max-width: 98%;
      width: 100%;

      &.ai {
        align-self: flex-start;
      }

      &.user {
        align-self: flex-end;
        flex-direction: row-reverse;
        justify-content: flex-end;
      }

      .avatar {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(26, 86, 219, 0.1);
        color: #1a56db;
        font-size: 1.5rem;
        border: 2px solid rgba(26, 86, 219, 0.2);
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }

      .message-content {
        padding: 12px 18px;
        border-radius: 16px;
        max-width: calc(100% - 55px); // 减去头像和间距的宽度
        word-wrap: break-word;
        word-break: break-word;
        line-height: 1.6;
        font-size: 0.95rem;
        overflow-wrap: break-word;
      }

      &.ai .message-content {
        background: rgba(26, 86, 219, 0.1);
        color: #1f2937;
        border: 1px solid rgba(26, 86, 219, 0.2);
        text-align: left;
      }

      &.user .message-content {
        background: #1a56db;
        color: white;
        align-self: flex-end;
        margin-left: auto;
      }
    }
  }

  .chat-input {
    display: flex;
    padding: 15px 20px;
    background: white;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    cursor: pointer;
    input {
      flex-grow: 1;
      padding: 12px 15px;
      border: 1px solid rgba(26, 86, 219, 0.2);
      border-radius: 24px;
      margin-right: 15px;
      background: #f8fafc;
      transition: all 0.3s;

      &:focus {
        outline: none;
        border-color: #1a56db;
        box-shadow: 0 0 0 3px rgba(26, 86, 219, 0.1);
      }
    }

    button {
      // pointer-events: none;
      background: #1a56db;
      color: white;
      border: none;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 10px rgba(26, 86, 219, 0.3);

      &:hover {
        background: darken(#1a56db, 10%);
        transform: translateY(-2px);
      }
    }
  }
}
</style>
